import m from "../../geodata/es2015/spainLow";
window.am4geodata_spainLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/spainLow.js
// module id = null
// module chunks = 